const e = `
	background-color: var(--_default-overlay-background-color);
`, a = `
	outline: var(--_focus-outline);
`, t = `
	background-color: var(--_hover-outline-background-color);
`, l = `
	background-color: var(--_hover-outline-inverse);
`, o = `
	background-color: var(--_on_hover-outline-background-color);
`, r = `
	font: var(--_label-lg-1-font);
	letter-spacing: var(--_label-lg-1-letter-spacing);
`, n = `
	font: var(--_label-md-1-font);
	letter-spacing: var(--_label-md-1-letter-spacing);
`, s = `
	font: var(--_label-md-2-font);
	letter-spacing: var(--_label-md-2-letter-spacing);
`, c = `
	font: var(--_label-sm-1-font);
	letter-spacing: var(--_label-sm-1-letter-spacing);
`, _ = `
	font: var(--_label-sm-2-font);
	letter-spacing: var(--_label-sm-2-letter-spacing);
`, v = `
	font: var(--_placeholder-font);
	letter-spacing: var(--_placeholder-letter-spacing);
`, g = `
	font: var(--_support-text-font);
	letter-spacing: var(--_support-text-letter-spacing);
`;
export {
  n as _,
  t as a,
  a as b,
  o as c,
  _ as d,
  c as e,
  r as f,
  e as g,
  v as h,
  g as i,
  s as j,
  l as k
};
